import React, { FunctionComponent } from 'react';

import { ResponseOptionValue } from '@bighealth/types/src';

import { ResponseForm } from 'components/forms/ResponseOptions/ResponseForm';
import { ResponseInput } from 'components/forms/ResponseOptions/ResponseInput';
import { roles } from 'cross-platform/utils/roleProps';

import { ScheduleNextSessionProps } from '../FormState';

import { FormikSubmitButton } from './FormikSubmitButton';
import { getDateTimePickerValue } from './getDateTimePickerValue';
import { handleValidate } from './handleValidate';
import {
  ContinueButton,
  ControlWrapper,
  SubmitButtonContainer,
  Title,
  WrapperForm,
} from './styled';

export type FormProps = {
  onSubmit: (value: ResponseOptionValue) => void;
  onContinue: () => void;
};

export type FormPresentationProps = ScheduleNextSessionProps & FormProps;

/** * Just renders. Handlers are configured elsewhere
 * @param props
 */
const FormPresentation: FunctionComponent<FormPresentationProps> = props => {
  return (
    <WrapperForm>
      <Title {...props?.title} />
      <ControlWrapper>
        <ResponseForm
          onSubmit={inputs => {
            // Data hard-coded, so we can assume there will be only one entry here
            // because there is only one response option
            Object.entries(inputs).forEach(([, optionsAnswer]) => {
              props?.onSubmit(getDateTimePickerValue(optionsAnswer));
            });
          }}
          onValidate={handleValidate}
        >
          <ResponseInput
            key={props?.questionProps.semantic_id}
            component={'DateTimePicker'}
            questionProps={props?.questionProps}
            initialValue={props?.initialValue}
            schedule_delay_in_minutes={props?.schedule_delay_in_minutes}
          />

          <SubmitButtonContainer>
            <FormikSubmitButton
              text={props?.submit_button.text}
            ></FormikSubmitButton>
          </SubmitButtonContainer>
        </ResponseForm>
      </ControlWrapper>

      <SubmitButtonContainer>
        <ContinueButton
          text={props?.continue_button.text}
          onPress={props?.onContinue}
          {...roles('ScheduleNextSession.ContinueButton')}
        ></ContinueButton>
      </SubmitButtonContainer>
    </WrapperForm>
  );
};

export { FormPresentation };
